import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState: {
  parent_activityData: any;
  parent_activityLoading: boolean;
  parent_activityError: SerializedError | null;
} = {
  parent_activityData: {},
  parent_activityLoading: false,
  parent_activityError: null,
};

export const parent_activityFunc = createAsyncThunk(
  'parent_activity/parent_activityFunc',
  async (values: { activityId: string }) => {
    const accessTokenJSON = localStorage.getItem('auth') as string;
    const data1 = JSON.stringify({
      query: `query Parent_activity($activityId: String!) {
      parent_activity(activityId: $activityId) {
        _id
        quota
        hoursBeforeReservationExpires
        fee
        externalLink
        externalMail
        externalPhoneNumber
        reservation {
        _id
        }
        createdBy {
          displayName
          displayImageUrl
          _id
          role
        }
        duration
        location {
          _id
          address {
            description
            title
          }
          city
          country
          district
          lat
          long
          parking
        }
        participantCount
        price
        title
        likedByParent
         listing {
          _id
          companionship
          exteriorOrganizer {
            _id
            contact {
              phoneNumber
              phoneNumber2
            }
            details
            imageUrl
            name
            socialMedia {
              facebook
              instagram
              twitter
              website
              youtube
            }
          }
          category
          images
          title
          format
          rating {
            average
            numberOfReviews
          }
          description
          coverImage
          ageInterval
           reviews {
            count
            data {
              _id
              comment
              createdAt
              createdBy {
                _id
                displayImageUrl
                displayName
              }
              rating
              title
            }
          }
        }
        schedule {
          startDate
          endDate
          days {
            _id
            activity {
              _id
            }
            date
            day
            startTime
            endTime
            createdAt
            updatedAt
          }
        }
        additionalDetails
      }
    }`,
      variables: {
        activityId: values?.activityId ?? null,
      },
    });

    const config = initialConfig(
      process.env.REACT_APP_BASE_URL_ACTIVITY || '',
      data1,
      JSON.parse(accessTokenJSON)?.accessToken || ''
    );

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const parent_activity = createSlice({
  name: 'parent_activity',
  initialState,
  reducers: {
    clearParentActivityData: (state) => {
      state.parent_activityData = {};
      state.parent_activityError = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(parent_activityFunc.pending, (state) => {
      state.parent_activityLoading = true;
    });
    builder.addCase(parent_activityFunc.fulfilled, (state, action) => {
      state.parent_activityLoading = false;
      state.parent_activityData = action.payload?.data?.parent_activity;
      state.parent_activityError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(parent_activityFunc.rejected, (state, action) => {
      state.parent_activityLoading = false;
      state.parent_activityError = action.error;
    });
  },
});

export const { clearParentActivityData } = parent_activity.actions;
export default parent_activity.reducer;
